import React, { useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';

import {
  Button,
  IcoMarketCycle,
  IconPeople,
  IcoStudies,
  PrimaryMarketIcon,
  SecondaryMarketIcon,
  TransactionsMarketIcon,
} from '../../component';
import Avatar from '../../component/avatar';
import { resetFilters } from './charts/redux/charts.actions';
import { setBigNumbers } from './bigNumbers/redux/bigNumbersActions';
import {
  openCloseUserOptions,
  setIsPressed,
} from './dataLayers/redux/dataLayers.actions';

import {
  clearMap,
  setDisplayCharts,
  setIsActive,
  setIsActiveRightSidebar,
  updateClusters,
  updateMarkers,
} from './redux/dashboardActions';
import { setShouldCleanPolygonsOnMap } from './socioeconomicDemographic/redux/socioeconomicDemographic.actions';
import { cleanHeatmap } from './heatmap/controllers/heatmap.controller';

export interface IMenuItem {
  id: string;
  label: string;
  icon: React.ReactNode;
  class: string;
  disabled: boolean;
}

type FloatingMenus = {
  hover: boolean;
  paddingTop: number;
  actionNumber: string;
};

type HoverLeftSidebar = {
  'Mercado primário de ofertados': FloatingMenus;
  'Mercado secundário de ofertados': FloatingMenus;
  'Imóveis transacionados': FloatingMenus;
  'Perfil socioeconômico e demográfico': FloatingMenus;
  'Ciclo de mercado': FloatingMenus;
  Relatórios: FloatingMenus;
};

export default function MenuSidebar() {
  const dispatch = useDispatch();

  const { profileRules } = useSelector((state: any) => state.layoutState);

  const { menuAction } = useSelector(
    (state: any) => state.dashboardState.isActive
  );

  const { shouldCleanPolygonsOnMap } = useSelector(
    (state: any) => state.socioeconomicDemographicState
  );

  const { markers, clusters } = useSelector(
    (state: any) => state.dashboardState
  );

  const hoverLeftSidebarInitialState: HoverLeftSidebar = {
    'Mercado primário de ofertados': {
      hover: false,
      paddingTop: 116,
      actionNumber: '1',
    },
    'Mercado secundário de ofertados': {
      hover: false,
      paddingTop: 116,
      actionNumber: '2',
    },
    'Imóveis transacionados': {
      hover: false,
      paddingTop: 174,
      actionNumber: '3',
    },
    'Perfil socioeconômico e demográfico': {
      hover: false,
      paddingTop: 232,
      actionNumber: '4',
    },
    'Ciclo de mercado': {
      hover: false,
      paddingTop: 348,
      actionNumber: '5',
    },
    Relatórios: {
      hover: false,
      paddingTop: 406,
      actionNumber: '6',
    },
  };

  const [hoverLeftSidebar, setHoverLeftSidebar] = useState<HoverLeftSidebar>(
    hoverLeftSidebarInitialState
  );
  const validatePermissions: () => IMenuItem[] = () => {
    const {
      hasAccessPrimary,
      hasAccessSecondary,
      hasAccessTransactions,
      hasAccessGeneralMarkets,
    } = profileRules;

    const optionsList: IMenuItem[] = [];

    if (hasAccessGeneralMarkets) {
      optionsList.push(
        {
          id: '7',
          label: 'Mercado primário de ofertados',
          icon: <PrimaryMarketIcon cy="PrimaryMarketIcon" />,
          class: 'large',
          disabled: false,
        },
        {
          id: '2',
          label: 'Mercado secundário de ofertados',
          icon: <SecondaryMarketIcon cy="SecondaryMarketIcon" />,
          class: 'large',
          disabled: false,
        },
        {
          id: '9',
          label: 'Imóveis transacionados',
          icon: <TransactionsMarketIcon cy="RealtyTransactionsIcon" />,
          class: 'large',
          disabled: false,
        }
      );
    } else {
      if (hasAccessPrimary || hasAccessSecondary) {
        optionsList.push(
          // {
          //   id: '1',
          //   label: 'Mercado primário de ofertados',
          //   icon: <PrimaryMarketIcon cy="PrimaryMarketIcon" />,
          //   class: 'large',
          //   disabled: false,
          // },
          {
            id: '2',
            label: 'Mercado secundário de ofertados',
            icon: <SecondaryMarketIcon cy="SecondaryMarketIcon" />,
            class: 'large',
            disabled: false,
          }
        );
      }
      if (hasAccessTransactions) {
        optionsList.push({
          id: '3',
          label: 'Imóveis transacionados',
          icon: <TransactionsMarketIcon cy="RealtyTransactionsIcon" />,
          class: 'large',
          disabled: false,
        });
      }

      optionsList.push({
        id: '4',
        label: 'Perfil socioeconômico e demográfico',
        icon: <IconPeople cy="SocioeconomicIcon" />,
        class: 'large',
        disabled: false,
      });
      // optionsList.push({
      //   id: '5',
      //   label: 'Ciclo de mercado',
      //   icon: <IcoMarketCycle cy="MarketCycleIcon" />,
      //   class: 'large',
      //   disabled: false,
      // });

      // optionsList.push({
      //   id: '6',
      //   label: 'Relatórios',
      //   icon: <IcoStudies cy="StudiesIcon" />,
      //   class: 'large',
      //   disabled: false,
      // });
    }

    return optionsList;
  };

  const menuMapa = validatePermissions();

  const actionMenu = (e: any) => {
    if (clusters.activeMap_ !== undefined) {
      markers.forEach((el: any) => {
        el.setMap(null);
      });
      clusters.clearMarkers();
      dispatch([resetFilters(), updateMarkers([]), updateClusters([])]);
    }

    if (shouldCleanPolygonsOnMap) {
      dispatch([
        setIsPressed(false),
        clearMap(),
        setShouldCleanPolygonsOnMap(false),
      ]);
    }
    cleanHeatmap();
    dispatch([
      setIsActive({
        name: 'mapAction',
        value: '',
      }),
      setIsActive({
        name: 'menuAction',
        value: e.id,
      }),
      setIsActiveRightSidebar({
        name: 'menuAction',
        value: '2',
      }),
      setBigNumbers(''),
      setDisplayCharts(null),
    ]);
  };

  const getInitialLettersUser = (): string => {
    return (
      sessionStorage.getItem('user_name')?.slice(0, 2).toUpperCase() || '??'
    );
  };

  return (
    <div className="menu-map">
      {menuMapa && menuMapa.length
        ? menuMapa.map((item) => {
            return (
              <div key={item.id}>
                <Button
                  cy={`ActivateMenuMapItem${item.id}`}
                  className={`${item.class} ${
                    menuAction === item.id ? 'active' : ''
                  }`}
                  onClick={() => actionMenu(item)}
                  onMouseEnter={() => {
                    setHoverLeftSidebar({
                      ...hoverLeftSidebarInitialState,
                      [item.label]: {
                        hover: true,
                        paddingTop:
                          hoverLeftSidebar[item.label as keyof HoverLeftSidebar]
                            .paddingTop,
                        actionNumber:
                          hoverLeftSidebar[item.label as keyof HoverLeftSidebar]
                            .actionNumber,
                      },
                    });
                  }}
                  onMouseLeave={() => {
                    setHoverLeftSidebar(hoverLeftSidebarInitialState);
                  }}
                  disabled={item.disabled ? item.disabled : false}
                >
                  {item?.icon ? item?.icon : null} <span>{item?.label}</span>
                </Button>
                {hoverLeftSidebar[item.label as keyof HoverLeftSidebar]
                  .hover && (
                  <div
                    style={{
                      position: 'fixed',
                      backgroundColor: '#383939',
                      color:
                        menuAction ===
                        hoverLeftSidebar[item.label as keyof HoverLeftSidebar]
                          .actionNumber
                          ? '#BA96D9'
                          : '#FFFFFF',
                      left: '60px',
                      padding: '5px',
                      borderRadius: '4px',
                      top: hoverLeftSidebar[
                        item.label as keyof HoverLeftSidebar
                      ].paddingTop,
                      fontFamily: 'Open Sans, sans-serif',
                    }}
                    data-cy="SidebarHoverLabel"
                  >
                    {item.label}
                  </div>
                )}
              </div>
            );
          })
        : null}

      <Avatar
        btnAction={() => {
          dispatch(openCloseUserOptions());
        }}
        content={getInitialLettersUser()}
        btnClass="sidebar-blocked"
      />
    </div>
  );
}
